<template>
    <div>
        <div class="display-flex display-flex-space-between margin-top-20">
            <FilterExcersice class="flex-left" @handleSeach="handleSeach" />
            <div class="wrap-right flex-right display-flex">
                <a href="javascript:;"
                    class="item btn btn-main btn-delete border-rd-20 font-size-16 display-flex-center item__add margin-right-10"
                    @click="handleOnDelete">
                    Xóa
                </a>
                <a href="javascript:;"
                    class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add margin-right-10"
                    @click="handleAddFolder">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Tạo Folder
                </a>
                <a href="javascript:;"
                    class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add margin-right-10"
                    @click="handleCreateExcercise">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Tạo đề
                </a>
                <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                    @click="handleOnCopy">
                    Sao chép đề
                </a>
            </div>
        </div>

        <div class="wrap-list-data col-md-12  margin-top-20"
            v-if="listDataFolder.length > 0 || listDataLessonClassSchool.length > 0" ref="scrollContainer"
            @scroll="handleScrollListLesson">
            <div class="header-table row">
                <div class="col-md-3">

                </div>
                <div class="col-md-3">
                    <div class="col-header">Loại đề</div>
                </div>
                <div class="col-md-2">
                    <div class="col-header">Khối</div>
                </div>
                <div class="col-md-2">
                    <div class="col-header">Môn</div>
                </div>
                <div class="col-md-1">
                </div>
                <div class="col-md-1">
                </div>
            </div>
            <div class="fit-data">
                <draggable :list="listDataFolder" @end="onDragEndFolder">
                    <transition-group type="transition">
                        <div class="folder-item" v-for="(item, index) of listDataFolder" :key="index">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="name-folder">
                                        <img class="icon-trash" src="@/assets/img/trash_light.png" v-if="isDeleted"
                                            @click="handleDeleteFolder(item)" />

                                        <a href="javascripts:;" class="text-primary" @click="handleCollapse(index)">
                                            {{ item.name }}
                                            <img class="icon-down-arrow"
                                                v-if="!listDataFolderCollapse[index].isCollapsed"
                                                src="@/assets/img/icon-down-arrow.png" />
                                            <img class="icon-up-arrow" v-else src="@/assets/img/icon-up-arrow.png" />
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <!-- <div class="col-header">Loại đề</div> -->
                                </div>
                                <div class="col-md-2">
                                    <!-- <div class="col-header">Khối</div> -->
                                </div>
                                <div class="col-md-2">
                                    <!-- <div class="col-header">Môn</div> -->
                                </div>
                                <div class="col-md-1">
                                    <img class="icon" src="@/assets/img/arrow.png" />
                                </div>
                                <div class="col-md-1">
                                    <b-dropdown size="lg" variant="link" toggle-class="custom-text-dropdown" no-caret>
                                        <template slot="button-content">
                                            <img class="icon" src="@/assets/img/icon-practice.png" alt />
                                        </template>
                                        <b-dropdown-item @click="handleEditName(item)" href="#">Sửa
                                            tên</b-dropdown-item>
                                        <b-dropdown-item @click="handleMoveAllExcerciseOutFolder(item)" href="#">Chuyển
                                            tất cả
                                            các đề ra khỏi folder</b-dropdown-item>
                                        <b-dropdown-item @click="handleAddExcerciseToFolder(item)" href="#">Thêm đề vào
                                            trong
                                            folder</b-dropdown-item>
                                        <!-- <b-dropdown-item @click="handleDeleteFolder(item)" href="#">Xóa thư
                                    mục</b-dropdown-item> -->
                                    </b-dropdown>

                                </div>
                            </div>
                            <b-collapse class="mt-1" :visible="listDataFolderCollapse[index].isCollapsed">
                                <div class="excersice-item row"
                                    v-for="(excercise, indexExcercise) of item.listDataExcercise" :key="indexExcercise">
                                    <div class="col-md-3 name-excercise indented">
                                        <img class="icon-trash" src="@/assets/img/trash_light.png" v-if="isDeleted"
                                            @click="handleDeleteExcercise(excercise)" />
                                        <img @click="handleCopyExcercise(excercise)" class="icon-copy"
                                            src="@/assets/img/files.png" v-if="isCopy" />
                                        <span @click="handleEditExcercise(excercise)">{{ excercise.name }}</span>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="col-header">{{ excercise.typeExcerciseName }}</div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="col-header">{{ excercise.className }}</div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="col-header">{{ excercise.subjectName }}</div>
                                    </div>
                                    <div class="col-md-1">
                                        <img class="icon" src="@/assets/img/arrow.png" />
                                    </div>
                                    <div class="col-md-1">
                                        <b-dropdown size="lg" variant="link" toggle-class="custom-text-dropdown"
                                            no-caret>
                                            <template slot="button-content">
                                                <img class="icon" src="@/assets/img/icon-practice.png" alt />
                                            </template>
                                            <!-- <b-dropdown-item @click="handleDeleteExcercise(excercise)" href="#">Xóa đề
                                        thi</b-dropdown-item> -->
                                            <b-dropdown-item @click="handleAssignExcercise(excercise)" href="#">Giao
                                                bài</b-dropdown-item>
                                            <b-dropdown-item @click="handleMoveExcerciseOutFolder(excercise)"
                                                href="#">Chuyển đề
                                                ra
                                                khỏi
                                                folder</b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </transition-group>
                </draggable>

                <draggable :list="listDataLessonClassSchool" @end="onDragEndDatalesson">
                    <transition-group type="transition">
                        <div class="excersice-item row margin-top-10" v-for="(item, index) of listDataLessonClassSchool"
                            :key="index">
                            <div class="col-md-3 name-excercise">
                                <img class="icon-trash" src="@/assets/img/trash_light.png" v-if="isDeleted"
                                    @click="handleDeleteExcercise(item)" />
                                <img @click="handleCopyExcercise(item)" class="icon-copy" src="@/assets/img/files.png"
                                    v-if="isCopy" />
                                <span @click="handleEditExcercise(item)">{{ item.name }}</span>
                            </div>
                            <div class=" col-md-3">
                                <div class="col-header">{{ item.typeExcerciseName }}</div>
                            </div>
                            <div class="col-md-2">
                                <div class="col-header">{{ item.className }}</div>
                            </div>
                            <div class="col-md-2">
                                <div class="col-header">{{ item.subjectName }}</div>
                            </div>
                            <div class="col-md-1">
                                <img class="icon" src="@/assets/img/arrow.png" />
                            </div>
                            <div class="col-md-1">
                                <b-dropdown size="lg" variant="link" toggle-class="custom-text-dropdown" no-caret>
                                    <template slot="button-content">
                                        <img class="icon" src="@/assets/img/icon-practice.png" alt />
                                    </template>
                                    <b-dropdown-item @click="handleMoveExcerciseToFolder(item)" href="#">Di chuyển đề
                                        vào
                                        folder</b-dropdown-item>
                                    <b-dropdown-item @click="handleAssignExcercise(item)" href="#">Giao
                                        bài</b-dropdown-item>
                                    <!-- <b-dropdown-item @click="handleDeleteExcercise(item)" href="#">Xóa đề
                                thi</b-dropdown-item> -->
                                </b-dropdown>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>



        </div>
        <div v-else>
            <div class="empty-data">
                Kho bài tập/bài kiểm tra không có dữ liệu
            </div>
        </div>
        <ModalMoveExcerciseToFolder :itemExcersice="itemExcersice" v-if="isMoveExcerciseToFolder"
            @closeModal="closeMoveExcerciseToFolder" @handleDone="handleDoneModalMoveExcerciseToFolder" />
        <ModalCreateOrUpdateFolder :item="itemFolderSelected" v-if="isOpenModalCreateUpdateFolder"
            @closeModal="closeModalFolder" @handleDone="handleDoneFolder" />
        <ModalDeleteFolder v-if="isOpenModalDeleteFolder" :item="itemFolderSelected"
            @closeModal="closeModalDeleteFolder" @handleDeleteDone="handleDeleteDone" />
        <ModalDeleteExcercise :item="itemExcersice" v-if="isOpenModalDeleteExcercise"
            @closeModal="closeModalDeleteExcercise" @handleDeleteDone="handleDeleteDoneExcercise" />
        <ModalAddExcerciseToFolder :folderItem="itemFolderSelected" v-if="isOpenModalAddExcerciseToFolder"
            @closeModal="closeModalAddExcerciseToFolder" @handleDone="handleAddExcerciseToFolderDone" />
        <ModalMoveExcerciseOutFolder :itemExcersice="itemExcersice" v-if="isOpenModalMoveExcerciseOutFolder"
            @closeModal="closeModalMoveExcerciseOutFolder" @handleDone="handleDoneModalMoveExcerciseOutFolder" />
        <ModalAssignExcercise :item="itemExcersice" :type="3" v-if="isOpenModalAssignExcercise"
            @closeModal="handleCloseModalAssignExcercise" />
        <ModalMoveAllExcerciseOutFolder :folderItem="itemFolderSelected" v-if="isModalMoveAllExcerciseOutFolder"
            @closeModal="handleCloseModalMoveAllExcerciseOutFolder"
            @handleDone="handleDoneModalMoveAllExcerciseOutFolder" />

        <ModalComfirmQuestionBank :type="0" :listDataQuestion="listDataQuestion"
            :dataDetailExcercise="dataDetailExcercise" :typeUpload="dataDetailExcercise.typeUploadExcercise"
            v-if="isOpenModalComfirmQuestionBank" @closeModal="handleCloseModalComfirmQuestionBank" />
        <ModalConfirmQuestionPdf :path="pathPdf" :dataDetailExcercise="dataDetailExcercise"
            :typeUpload="dataDetailExcercise.typeUploadExcercise" v-if="isOpenModalConfirmQuestionPdf"
            @closeModal="handleCloseModalConfirmQuestionPdf" />
    </div>
</template>
<script>
import ModalDeleteFolder from './_components/ModalDeleteFolder'
import FilterExcersice from './_components/FilterExcersice'
import ModalCreateOrUpdateFolder from './_components/ModalCreateOrUpdateFolder'
import { getListExcerciseClassSchool, changeOrderLesson, getDetailExcercise } from './../../_api/LessonClassSchoolServices'

import { listFolderExcerciseClassSchool, changeOrderFolder } from './../../_api/folderExcerciseClassSchoolServices'
import ModalDeleteExcercise from './_components/ModalDeleteExcercise'
import ModalAddExcerciseToFolder from './_components/ModalAddExcerciseToFolder'
import ModalMoveExcerciseOutFolder from './_components/ModalMoveExcerciseOutFolder'
import ModalAssignExcercise from './_components/ModalAssignExcercise.vue'
import ModalMoveExcerciseToFolder from './_components/ModalMoveExcerciseToFolder'
import ModalMoveAllExcerciseOutFolder from './_components/ModalMoveAllExcerciseOutFolder'
import draggable from 'vuedraggable'
import ModalComfirmQuestionBank from './_components/ModalComfirmQuestionBank'
import ModalConfirmQuestionPdf from './_components/ModalConfirmQuestionPdf'
export default {
    components: {
        FilterExcersice,
        ModalCreateOrUpdateFolder,
        ModalDeleteFolder,
        ModalDeleteExcercise,
        ModalAddExcerciseToFolder,
        ModalMoveExcerciseOutFolder,
        ModalAssignExcercise,
        ModalMoveExcerciseToFolder,
        ModalMoveAllExcerciseOutFolder,
        draggable,
        ModalComfirmQuestionBank,
        ModalConfirmQuestionPdf
    },
    data() {
        return {
            isLoading: false,
            isOpenModalCreateUpdateFolder: false,
            isOpenModalDeleteFolder: false,
            isOpenModalDeleteExcercise: false,
            isOpenModalAddExcerciseToFolder: false,
            isOpenModalMoveExcerciseOutFolder: false,
            isOpenModalAssignExcercise: false,
            isMoveExcerciseToFolder: false,
            isModalMoveAllExcerciseOutFolder: false,
            isOpenModalComfirmQuestionBank: false,
            isOpenModalConfirmQuestionPdf: false,
            paramQueryFolder: {
                keyword: '',
                pageIndex: 1,
                subjectId: 0,
                classId: 0,
                typeExcercise: 0,
                pageSize: 1000000,
            },
            listDataFolder: [],
            listDataFolderCollapse: [],
            itemFolderSelected: null,
            itemExcersice: null,
            paramQueryDataLesson: {
                keyword: '',
                pageIndex: 1,
                type: 3,
                pageSize: 20,
                subjectId: 0,
                classId: 0,
                typeExcercise: 0,
                isGetDataHasFolder: false
            },
            listDataLessonClassSchool: [],
            totalRecords: 0,
            totalPage: 0,
            isDeleted: false,
            dataDetailExcercise: {},
            listDataQuestion: [],
            pathPdf: '',
            isCopy: false,
        }
    },
    mounted() {

        this.getListDataFolder()
        this.getListLessonClassSchool()
    },
    methods: {
        handleCloseModalConfirmQuestionPdf() {
            this.isOpenModalConfirmQuestionPdf = false
        },
        handleCloseModalComfirmQuestionBank() {
            this.isOpenModalComfirmQuestionBank = false
        },
        handleCopyExcercise(item) {
            this.GetDetailExcerciser(item, true)
        },
        GetDetailExcerciser(item, isCopy = false) {
            this.listDataQuestion = []
            getDetailExcercise(item.id).then((res) => {
                if (res && res.data && !res.errors) {
                    this.dataDetailExcercise = res.data
                    if (isCopy) {
                        this.dataDetailExcercise.id = 0
                        //
                        this.dataDetailExcercise.name = `Bản sao ` + this.dataDetailExcercise.name
                    }
                    if (this.dataDetailExcercise.typeUploadExcercise == 1 || this.typeUploadExcercise == 2) {
                        for (let i = 0; i < this.dataDetailExcercise.listExcerciseQuestionClassSchool.length; i++) {
                            const item = this.dataDetailExcercise.listExcerciseQuestionClassSchool[i];
                            this.listDataQuestion.push({ ...item.question, point: item.point })
                        }
                        this.isOpenModalComfirmQuestionBank = true
                    }
                    else if (this.dataDetailExcercise.typeUploadExcercise == 3 || this.dataDetailExcercise.typeUploadExcercise == 4) {
                        for (let i = 0; i < this.dataDetailExcercise.listExcerciseQuestionClassSchool.length; i++) {
                            const item = this.dataDetailExcercise.listExcerciseQuestionClassSchool[i];
                            this.listDataQuestion.push({ ...item })
                        }
                        this.isOpenModalComfirmQuestionBank = true
                    }
                    else if (this.dataDetailExcercise.typeUploadExcercise == 5 || this.dataDetailExcercise.typeUploadExcercise == 6) {
                        this.pathPdf = this.dataDetailExcercise.path

                        this.isOpenModalConfirmQuestionPdf = true
                    }


                }
            })
        },
        handleEditExcercise(item) {
            this.GetDetailExcerciser(item)
        },
        onDragEndDatalesson(e) {
            //listDataLessonClassSchool
            let listOrder = []

            for (let i = e.oldIndex; i <= e.newIndex; i++) {
                const item = this.listDataLessonClassSchool[i];
                listOrder.push(Number(item.id))
            }
            listOrder.sort(function (a, b) {
                return b - a;
            })
            console.log(listOrder)
            let listParams = []
            for (let i = e.oldIndex; i <= e.newIndex; i++) {
                const item = this.listDataLessonClassSchool[i];
                listParams.push({ id: item.id, orderNo: listOrder[i] })
            }
            changeOrderLesson(listParams)
        },
        onDragEndFolder() {
            let listOrder = []

            for (let i = 0; i < this.listDataFolder.length; i++) {
                const item = this.listDataFolder[i];
                listOrder.push(Number(item.orderNo))
            }

            listOrder.sort(function (a, b) {
                return b - a;
            })

            let listParams = []
            for (let i = 0; i < this.listDataFolder.length; i++) {
                const item = this.listDataFolder[i];
                listParams.push({ id: item.id, orderNo: listOrder[i] })
            }
            changeOrderFolder(listParams)
        },
        handleMoveAllExcerciseOutFolder(item) {
            this.itemFolderSelected = item
            this.isModalMoveAllExcerciseOutFolder = true
        },
        handleOnDelete() {
            this.isDeleted = !this.isDeleted
        },
        handleOnCopy() {
            this.isCopy = !this.isCopy
        },
        handleDoneModalMoveAllExcerciseOutFolder() {
            this.resetData()
            this.getListDataFolder()
            this.getListLessonClassSchool()
            this.handleCloseModalMoveAllExcerciseOutFolder()
        },
        handleCloseModalMoveAllExcerciseOutFolder() {
            this.isModalMoveAllExcerciseOutFolder = false
        },
        handleDoneModalMoveExcerciseToFolder() {
            this.resetData()
            this.getListDataFolder()
            this.getListLessonClassSchool()
            this.closeMoveExcerciseToFolder()
        },
        closeMoveExcerciseToFolder() {
            this.isMoveExcerciseToFolder = false
        },
        handleMoveExcerciseToFolder(item) {
            this.itemExcersice = item
            this.isMoveExcerciseToFolder = true
        },
        handleSeach(filter) {
            this.resetData()
            this.paramQueryFolder.keyword = filter.keyword
            this.paramQueryFolder.subjectId = filter.subjectId
            this.paramQueryFolder.classId = filter.classId
            this.paramQueryFolder.typeExcercise = filter.typeExcercise

            this.paramQueryDataLesson.keyword = filter.keyword,
                this.paramQueryDataLesson.subjectId = filter.subjectId,
                this.paramQueryDataLesson.classId = filter.classId
            this.paramQueryDataLesson.typeExcercise = filter.typeExcercise
            this.getListDataFolder()
            this.getListLessonClassSchool()
        },
        handleAssignExcercise(item) {
            console.log(item)
            this.itemExcersice = item
            this.isOpenModalAssignExcercise = true
        },
        handleCloseModalAssignExcercise() {
            this.isOpenModalAssignExcercise = false
        },
        handleDoneModalMoveExcerciseOutFolder() {
            this.getListDataFolder()
            this.resetData()
            this.getListLessonClassSchool()
            this.closeModalAddExcerciseToFolder()
        },
        closeModalMoveExcerciseOutFolder() {
            this.isOpenModalMoveExcerciseOutFolder = false
        },
        handleMoveExcerciseOutFolder(excercise) {
            this.itemExcersice = excercise
            this.isOpenModalMoveExcerciseOutFolder = true
        },
        handleAddExcerciseToFolderDone() {
            this.getListDataFolder()
            this.resetData()
            this.getListLessonClassSchool()
            this.closeModalAddExcerciseToFolder()
        },
        closeModalAddExcerciseToFolder() {
            this.isOpenModalAddExcerciseToFolder = false
        },
        handleAddExcerciseToFolder(item) {
            this.itemFolderSelected = item
            this.isOpenModalAddExcerciseToFolder = true
        },
        resetData() {
            this.paramQueryDataLesson.pageIndex = 1
            this.listDataLessonClassSchool = [],
                this.totalRecords = 0,
                this.totalPage = 0
        },
        handleDeleteDoneExcercise() {
            this.resetData()
            this.getListLessonClassSchool()
            this.closeModalDeleteExcercise()
            this.isDeleted = !this.isDeleted
        },
        closeModalDeleteExcercise() {
            this.isOpenModalDeleteExcercise = false
        },
        handleDeleteExcercise(item) {
            this.itemExcersice = item
            this.isOpenModalDeleteExcercise = true
        },
        handleScrollListLesson() {
            const container = this.$refs.scrollContainer;
            const scrollHeight = container.scrollHeight;
            const scrollTop = container.scrollTop;
            const offsetHeight = container.offsetHeight;
            const bottomOffset = scrollHeight - (scrollTop + offsetHeight);
            if (bottomOffset <= 0 && !this.isLoading) {
                // Load more items when the user reaches the bottom with some offset
                let pageIndexSearch = this.paramQueryDataLesson.pageIndex + 1
                if (pageIndexSearch <= this.totalPage) {
                    this.paramQueryDataLesson.pageIndex++
                    this.getListLessonClassSchool()
                }

            }
        },
        getListLessonClassSchool() {
            let self = this
            getListExcerciseClassSchool(this.paramQueryDataLesson).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        self.listDataLessonClassSchool.push({ ...item })
                    }

                    self.totalRecords = res.data.paging.totalRecords
                    self.totalPage = res.data.paging.totalPage
                }
            })
        },
        handleDeleteDone() {
            this.getListDataFolder()
            this.closeModalDeleteFolder()
            this.isDeleted = !this.isDeleted
        },
        closeModalDeleteFolder() {
            this.isOpenModalDeleteFolder = false
        },
        handleDeleteFolder(item) {
            this.itemFolderSelected = item
            this.isOpenModalDeleteFolder = true
        },

        handleDoneFolder() {
            this.getListDataFolder()
            this.closeModalFolder()
        },
        handleEditName(item) {
            this.itemFolderSelected = item
            this.isOpenModalCreateUpdateFolder = true
        },
        closeModalFolder() {
            this.isOpenModalCreateUpdateFolder = false
        },
        handleAddFolder() {
            this.itemFolderSelected = null
            this.isOpenModalCreateUpdateFolder = true
        },
        handleCreateExcercise() {
            //
            const routeData = this.$router.resolve({ path: '/tao-bai-kiem-tra' });
            window.open(routeData.href, '_blank');
        },
        getListDataFolder() {
            let self = this
            listFolderExcerciseClassSchool(this.paramQueryFolder).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataFolder = res.data.list
                }

                //Lấy list các biến collapse của folder
                this.listDataFolderCollapse = []
                for (let i = 0; i < res.data.list.length; i++) {
                    this.listDataFolderCollapse.push({ 'isCollapsed': false });
                }
            })
        },
        handleCollapse(index) {
            if (this.listDataFolderCollapse.length > 0) {
                for (let i = 0; i < this.listDataFolderCollapse.length; i++) {
                    if (i != index) {
                        this.listDataFolderCollapse[i].isCollapsed = false
                    }
                }
                this.listDataFolderCollapse[index].isCollapsed = !this.listDataFolderCollapse[index].isCollapsed
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.name-excercise {
    color: blue;
    cursor: pointer;
}

.flex-left {
    flex: 2;
}

.flex-right {
    flex: 1;
}

.header-table {
    .col-header {
        color: gray;
    }

}

.indented {
    padding-left: 40px;
    /* Đặt giá trị thụt cách tùy ý */
}

.wrap-list-data {
    max-height: 18rem;
    overflow-y: scroll;
}

.wrap-list-data {
    .folder-item {
        .name-folder {
            color: #131a62;
            font-weight: 600;
        }
    }

    .icon {
        width: 20px;
        height: 20px;
    }
}

.margin-top-10 {
    margin-top: 10px;
}

.margin-top-20 {
    margin-top: 20px;
}

.margin-right-10 {
    margin-right: 10px;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.display-flex-space-between {
    justify-content: space-between;
}

.btn-delete {
    color: white;
    background: red;
    padding: 5px 20px 5px 20px;
    border-radius: 15px;
    font-family: sans-serif;
    border: 1px solid red;
}

.btn-main {
    width: max-content;
}

.empty-data {
    text-align: center;
}

.icon-copy {
    margin: 0 5px;
}
</style>